// src/components/organisms/WeatherForecastDisplay.js
import React from 'react';
import ForecastBadge from '../molecules/ForecastBadge';
import './WeatherForecastDisplay.css';

const WeatherForecastDisplay = ({ data }) => {

  const forecastFirstDay = {
    dateDay: data.forecastToday.day0.dateDay,
    weatherDay: data.forecastToday.day0.times[0].condition,
    temperatureDay: data.forecastToday.day0.times[0].temperature,
    weatherNight: data.forecastToday.day0.times[1].condition,
    temperatureNight: data.forecastToday.day0.times[1].temperature
  };
  const forecastSecondDay = {
    dateDay: data.forecastToday.day1.dateDay,
    weatherDay: data.forecastToday.day1.times[0].condition,
    temperatureDay: data.forecastToday.day1.times[0].temperature,
    weatherNight: data.forecastToday.day1.times[1].condition,
    temperatureNight: data.forecastToday.day1.times[1].temperature
  };
  const forecastThirdDay = {
    dateDay: data.forecastToday.day2.dateDay,
    weatherDay: data.forecastToday.day2.times[0].condition,
    temperatureDay: data.forecastToday.day2.times[0].temperature,
    weatherNight: data.forecastToday.day2.times[1].condition,
    temperatureNight: data.forecastToday.day2.times[1].temperature
  };


  return (
    <div className='forecast-box'>
      <div className='forecast-text'>
          <div>FORECAST</div>
        </div>
      <div className="weather-forecast-display">
        <ForecastBadge data={forecastFirstDay} ></ForecastBadge>
        <ForecastBadge data={forecastSecondDay} ></ForecastBadge>
        <ForecastBadge data={forecastThirdDay} ></ForecastBadge>
      </div>
    </div>
  );
};

export default WeatherForecastDisplay;
